// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app {\r\n  font-family: \"Noto Sans SC\", \"Amontserratrial\", Helvetica, sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  font-weight: 300;\r\n  /*text-align: center;*/\r\n  width:100%;\r\n  height:100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
